import { MutOpt } from '@/app/api';
import { queryClient } from '@/lib/query-client';
import { createQueryKeys } from '@/lib/query-factory';
import { queryOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import * as api from './labels.api';

const keys = createQueryKeys('labels');

export const labelQueries = {
  keys,
  list: () =>
    queryOptions({
      queryKey: keys.list(),
      queryFn: () => api.fetchLabels(),
    }),
  detail: (id: number) =>
    queryOptions({
      queryKey: keys.detail(id),
      queryFn: () => api.fetchLabel(id),
      enabled: !!id,
    }),
};

export const labelMutations = {
  create: (): MutOpt<typeof api.createLabel> => ({
    mutationFn: api.createLabel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.lists() });
      toast.success('Label created');
    },
    onError: (error: Error) => {
      toast.error('Failed to create label', {
        description: error.message,
      });
    },
  }),
  update: (): MutOpt<typeof api.updateLabel> => ({
    mutationFn: api.updateLabel,
    onSuccess: (_, { recnum }) => {
      queryClient.invalidateQueries({ queryKey: keys.detail(recnum) });
      queryClient.invalidateQueries({ queryKey: keys.lists() });
      toast.success('Label updated');
    },
    onError: (error: Error) => {
      toast.error('Failed to update label', {
        description: error.message,
      });
    },
  }),
  delete: (): MutOpt<typeof api.deleteLabel> => ({
    mutationFn: api.deleteLabel,
    onSuccess: (_, recnum) => {
      queryClient.invalidateQueries({ queryKey: keys.detail(recnum) });
      queryClient.invalidateQueries({ queryKey: keys.lists() });
      toast.success('Label deleted');
    },
    onError: (error: Error) => {
      toast.error('Failed to delete label', {
        description: error.message,
      });
    },
  }),
};
